var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 2.56033V6.58333C14.5833 6.99755 14.9191 7.33333 15.3333 7.33333C15.7475 7.33333 16.0833 6.99755 16.0833 6.58333V0.75C16.0833 0.335786 15.7475 0 15.3333 0H9.5C9.08579 0 8.75 0.335786 8.75 0.75C8.75 1.16421 9.08579 1.5 9.5 1.5H13.5223L7.30268 7.71967C7.00978 8.01256 7.00978 8.48744 7.30268 8.78033C7.59557 9.07322 8.07045 9.07322 8.36334 8.78033L14.5833 2.56033Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 2.75C2.28338 2.75 1.5 3.53338 1.5 4.5V12.8333C1.5 13.8 2.28338 14.5833 3.25 14.5833H11.5833C12.55 14.5833 13.3333 13.8 13.3333 12.8333V8.66667C13.3333 8.25245 13.6691 7.91667 14.0833 7.91667C14.4975 7.91667 14.8333 8.25245 14.8333 8.66667V12.8333C14.8333 14.6284 13.3784 16.0833 11.5833 16.0833H3.25C1.45495 16.0833 0 14.6284 0 12.8333V4.5C0 2.70495 1.45495 1.25 3.25 1.25H7.41667C7.83088 1.25 8.16667 1.58579 8.16667 2C8.16667 2.41421 7.83088 2.75 7.41667 2.75H3.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.19ea503e34a4ba9fc52e47dd71d8b93e.svg";
export { ForwardRef as ReactComponent };